import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";
import { useLanguage } from "../contexts/LanguageContext";
import MobileDrawer from "./MobileDrawer";

const MobileNavigation = ({
  onNavigate,
  isPageHeader = false,
  className = "",
  headerOnly = false,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { language, toggleLanguage } = useLanguage();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleSearchToggle = () => {
    navigate("/search");
  };

  const handleLanguageToggle = (e) => {
    e.preventDefault();
    toggleLanguage();
  };

  const handleNavigation = (section) => {
    if (isPageHeader) {
      // When on page headers, handle navigation based on section
      if (section === "home") {
        navigate("/");
      } else if (section === "services") {
        navigate("/services");
      } else if (section === "offers") {
        navigate("/offers");
      } else {
        // For other sections (about, contact, etc.), go to home with hash
        navigate(`/#${section}`);
      }
    } else if (onNavigate) {
      onNavigate(section);
    } else if (section === "home") {
      navigate("/");
    } else if (section === "services") {
      navigate("/services");
    } else if (section === "offers") {
      navigate("/offers");
    } else {
      navigate(`/#${section}`);
    }
  };

  return (
    <>
      <nav
        className={`mobile-navigation ${className} ${
          isPageHeader ? "page-header-nav" : ""
        }`}
      >
        <div className="nav-content">
          {/* Navigation Links - Hidden when headerOnly */}
          {!headerOnly && (
            <div className="nav-links">
              <a
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("home");
                }}
              >
                {t("nav.home")}
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("about");
                }}
                className=""
              >
                {t("nav.aboutUs")}
              </a>
              <a
                href="/services"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("services");
                }}
              >
                {t("nav.ourServices")}
              </a>
              <a
                href="/offers"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("offers");
                }}
              >
                {t("nav.specialOffers")}
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("contact");
                }}
                className=""
              >
                {t("nav.contactUs")}
              </a>
              <a
                href="#"
                onClick={handleLanguageToggle}
                className="language-nav-link "
              >
                {language === "en"
                  ? t("language.arabic")
                  : t("language.english")}
              </a>
            </div>
          )}

          {/* Search button - Always visible */}
          <div className="nav-search-item">
            <button
              className="search-toggle"
              onClick={handleSearchToggle}
              aria-label="Toggle search"
            >
              <svg
                viewBox="0 -0.5 21 21"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                fill="currentColor"
                width="20px"
                height="20px"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <title>search_left [#1504]</title>
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Dribbble-Light-Preview"
                      transform="translate(-299.000000, -280.000000)"
                      fill="currentColor"
                    >
                      <g
                        id="icons"
                        transform="translate(56.000000, 160.000000)"
                      >
                        <path
                          d="M264,138.586 L262.5153,140 L258.06015,135.758 L259.54485,134.343 L264,138.586 Z M251.4,134 C247.9266,134 245.1,131.309 245.1,128 C245.1,124.692 247.9266,122 251.4,122 C254.8734,122 257.7,124.692 257.7,128 C257.7,131.309 254.8734,134 251.4,134 L251.4,134 Z M251.4,120 C246.7611,120 243,123.582 243,128 C243,132.418 246.7611,136 251.4,136 C256.0389,136 259.8,132.418 259.8,128 C259.8,123.582 256.0389,120 251.4,120 L251.4,120 Z"
                          id="search_left-[#1504]"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <span className="search-text">{t("nav.search")}</span>
            </button>

            {/* Hamburger Menu Button */}
            <button
              className="hamburger-menu-btn"
              onClick={() => setIsDrawerOpen(true)}
              aria-label="Open menu"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>

        </div>
      </nav>

      {/* Mobile Drawer */}
      <MobileDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
};

export default MobileNavigation;
